<script setup lang="ts">
import { computed } from 'vue';
import { humanReadableDate, DateFormat } from '@/utils/date';
import OverflowTooltip from '@/components/OverflowTooltip.vue';

const props = defineProps<{
  field: string;
  dataType: string;
  data: any;
}>();

function formatDate(value: string | number | Date | null) {
    if (value !== null) {
        const dateValue = new Date(value);
      if (!isNaN(dateValue.getTime())) {
        // Check if the original value contains time information
        let hasTime = false;

        if (typeof value === 'string') {
          // Check if string contains time components (HH:mm, HH:mm:ss, etc.)
          hasTime = /T\d{2}:\d{2}/.test(value) || /\d{2}:\d{2}/.test(value);
        } else {
          // For Date objects or numbers, check if time components are non-zero
          hasTime = dateValue.getUTCHours() !== 0 ||
                   dateValue.getUTCMinutes() !== 0 ||
                   dateValue.getUTCSeconds() !== 0 ||
                   dateValue.getUTCMilliseconds() !== 0;
        }

        if (hasTime) {
          return humanReadableDate(dateValue, DateFormat.DATETIME_HUMAN);
        }

        // Date only, as mm/dd/yy: the same format the search cards print for a plain date.
        return ('0' + (dateValue.getUTCMonth() + 1)).slice(-2) + '/' +
          ('0' + dateValue.getUTCDate()).slice(-2) + '/' +
          String(dateValue.getUTCFullYear()).slice(-2);
      }
    }
    return '';
}

const displayValue = computed(() => formatDate(props.data?.[props.field]));
</script>

<template>
  <OverflowTooltip :deps="displayValue">{{ displayValue }}</OverflowTooltip>
</template>
